import { observer } from 'mobx-react-lite';
import "./WebHomePage.css";  
import { useEffect, useState } from 'react';
import { ScrollRestoration, useLocation } from 'react-router-dom';
import { useStore } from '../../app/stores/rootStore';
export default observer(function ContactUsPage() {
    const { commonStore,modalStore } = useStore();
    const currentyear = new Date().getFullYear();
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    const [toggleBtn, setToggleBtn] = useState(true);
  const toggle = () => setToggleBtn(val => !val);
    return (
      <>
      <section data-bs-version="5.1" className="slider6 mbr-embla cid-uCWekBrajo mt-3" id="slider6-s" style={{paddingTop:'110px'}}>
    
    
    <div className="position-relative">
        <div className="mbr-section-head">
            <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2"><strong>Connect Us</strong></h4>
            <h5 className="mbr-section-subtitle mbr-fonts-style align-center mb-0 mt-2 display-5">We'd love to hear from you! Whether you have a question, need assistance, or want to share feedback, our team is here to help</h5>
        </div>        
    </div>
</section>
<section data-bs-version="5.1" className="contacts1 map1 tabs cid-uBD0A9vN7j" id="contacts1-n">  

      
    <div className="container">
        <div className="row reverse">            
            <div className="col-12 col-lg-6 mbr-form form" data-form-type="formoid">
                    <div className="row">
                    </div>
                    <div className="dragArea row">
                        <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                            <div className="row">
                                <div className="col">
                                    <input type="text" name="nameFirst" placeholder="First Name" data-form-field="nameFirst" className="form-control text-multiple" value="" id="nameFirst-contacts1-n" />
                                </div>
                                <div className="col">
                                    <input type="text" name="nameLast" placeholder="Last Name" data-form-field="nameLast" className="form-control text-multiple" value="" id="nameLast-contacts1-n" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                            <div className="row">
                                <div className="col">
                                    <input type="email" name="email" placeholder="E-mail" data-form-field="email" className="form-control" value="" id="email-contacts1-n" />
                                </div>
                                <div className="col">
                                    <input type="url" name="url" placeholder="Your Site" data-form-field="url" className="form-control display-4" value="" id="url-contacts1-n" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 form-group" data-for="textarea">
                            <textarea name="textarea" placeholder="Message" data-form-field="textarea" className="form-control display-4" id="textarea-contacts1-n"></textarea>
                        </div>
                    </div>                
                <h5 className="link-title mbr-fonts-style mt-2 display-4">
                    <a href="index.html" className="text-black">Submit message</a>
                </h5>
            </div>
            <div className="col-12 col-lg-6 p-0">                
                <div className="col-12 p-0">
                    <div className="map-wrap">
                        <div className="google-map"><iframe style={{border:'0'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.3839742806244!2d77.3876161!3d28.5582304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cef6b7c953e9f%3A0x5cee50f81bf99e62!2sVoguish%20Trendy%20Couture!5e0!3m2!1sen!2sin!4v1774073360861!5m2!1sen!2sin"></iframe></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
      </>      
    )
})